module.exports = __webpack_public_path__ + "static/media/valor1_2_2.b6f196c0.png";